"use strict";
import largeStyles from "../src/express/scale-large.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/express/core.dev.js";
Theme.registerThemeFragment("large-express", "scale", largeStyles);
//# sourceMappingURL=scale-large.dev.js.map
